import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS, handleErrorForm,
  gridSizeMdLg12,
  SegmentacionENUM, texto, gridSizeMdLg6,
  TIPO_IDENTIFICACIONES_CHOICE, TipoIdentificacionEnumChoice,
  gridSizeConst10, gridSizeConst2, subtractHundredYears,
  formatDate, calcularEdad, handleAxiosError,
  formatDateWithTimeAMPM, EstadoProspectoEnum, gridSizeMdLg5,
  hasPermission
} from "@/shared";
import { postSolicitudFallido, postSolicitudSupervicion } from "@/shared/actions/erp";
import {
  SingleTableBoxScene, TabTextLabel, CustomAutocompleteArrString,
  CustomTextFieldNumberComponente,
  CustomTextField, SampleDatePicker,
  CustomAutocomplete, CustomTextFieldNoForm, SampleCheckbox,
  CustomAutocompleteNoForm,
  CustomTextArea,
} from "@/shared/components/ui";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import {
  ErrorMessagesForm,
  TipoDocumentoNameEnum,
  RangoEdadEnum,
  AlertSeverityEnum, Pais
} from "@/shared/interfaces";
import { Grid, Alert, AlertTitle, Typography, IconButton } from "@mui/material";
import { useFormProspecto } from "../../hook";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SearchIcon from '@mui/icons-material/Search';
import ModalReportadoTelco from "../ModalReportadoTelco/ModalReportadoTelco";
import EstadoBeneficioCard from "../EstadoBeneficioCard/EstadoBeneficioCard";
import ExcelDownloadLoader from "@/erp/inventario/kardex/componente/ExcelDownloadLoader";

const ESTADO_CONTRIBUYENTE_RUC = ['ACTIVO', 'SUSPENDIDO']
const TIPO_CONTRIBUYENTE_RUC = ['SOCIEDAD', 'PERSONA NATURAL']
const REGIMEN_RUC = ['RIMPE', 'GENERAL']

export enum solicitudBeneficioProspectoEnum {
  NO_APLICA = 'NO_APLICA',
  FAMILIAR_CON_DISCAPACIDAD = "FAMILIAR_CON_DISCAPACIDAD",
  USUARIO_DE_BONO_DESARROLLO_HUMANO = "USUARIO_DE_BONO_DESARROLLO_HUMANO",
  AYUDA_SOCIAL = "AYUDA_SOCIAL",
  APLICA_GREMIO = "APLICA_GREMIO",
}

export const SOLICITUD_BENEFICIO_PROSPECTO_OPTIONS = [
  {
    codigo: "NO_APLICA",
    nombre: "NO APLICA"
  },
  {
    codigo: "AYUDA_SOCIAL",
    nombre: "AYUDA SOCIAL"
  },
  {
    codigo: "APLICA_GREMIO",
    nombre: "APLICA GREMIO"
  },
  {
    codigo: "FAMILIAR_CON_DISCAPACIDAD",
    nombre: "FAMILIAR CON DISCAPACIDAD"
  },
  {
    codigo: "USUARIO_DE_BONO_DESARROLLO_HUMANO",
    nombre: "USUARIO DE BONO DESARROLLO HUMANO"
  }
]

export const SOLICITUD_BENEFICIO_SCORE_BAJO = [
  {
    codigo: "NO_APLICA",
    nombre: "NO APLICA"
  },
  {
    codigo: "AYUDA_SOCIAL",
    nombre: "AYUDA SOCIAL"
  },
  {
    codigo: "FAMILIAR_CON_DISCAPACIDAD",
    nombre: "FAMILIAR CON DISCAPACIDAD"
  }
]

export default function SaveProspecto() {

  const {
    //state
    esDifunto,
    setEsDifunto,
    esReportado,
    setEsReportado,
    esCliente,
    setEsCliente,
    tutorDiscapacidad,
    setDisableIdentification,
    disableIdentification,
    setAlert,
    nombreRazonSocial,
    esResidente,
    MotivoSolicitudBeneficio,
    //setMotivoSolicitudBeneficio,
    scoreBajo,
    setScoreBajo,

    //
    isLoadingPais,
    dataPais,
    //checkedDiscapacidad,
    //setcheckedDiscapacidad,
    //form
    form,
    control,
    reset,
    errors,
    setError,
    //fn
    onSubmit,
    fnBuscarIdentificacion,
    handleFamiliarConDiscapacidad,

    setModalProspectoEnEspera,
    modalProspectoEnEspera,
    setModalProspectoEnProceso,
    modalProspectoEnProceso,
    dataProspectoEnEspera,
    dataProspectoEnProceso,

    ///*Carga de imagenes para beneficio
    UploadImageComponent,
    fotoTutorDiscapacidad,
    setFotoTutorDiscapacidad,
    fotoDocumentoLegalRepresentante,
    setFotoDocumentoLegalRepresentante,

    aplicaSolicitudBeneficio,
    handleBuscarIdentificacion,

    fileIdentificacion, setFileIdentificacion,
    fileCredencialEmpresa, setFileCredencialEmpresa,
    //fileDocLegalEmpresa, setFileDocLegalEmpresa,
    setMotivoSolicitudBeneficio,
    cleanProspecto,
    dataSolicitudBeneficio,
    valorRestriccionCel
  } = useFormProspecto();

  const bloquearVenta = form.getValues("reportado") || false;

  function onChangeBeneficio(beneficio: string) {
    setMotivoSolicitudBeneficio(beneficio)
    console.log(beneficio);

    reset({
      ...form.getValues(),
      es_curador_tutor: beneficio == solicitudBeneficioProspectoEnum.FAMILIAR_CON_DISCAPACIDAD,
      es_bono_humano: beneficio == solicitudBeneficioProspectoEnum.USUARIO_DE_BONO_DESARROLLO_HUMANO,
      es_ayuda_social: beneficio == solicitudBeneficioProspectoEnum.AYUDA_SOCIAL,
      es_gremio: beneficio == solicitudBeneficioProspectoEnum.APLICA_GREMIO
    });
  }


  return (
    <>
      <SingleTableBoxScene
        py={1}
        title={"Prospecto"}
        iconRedirect={<FormatListBulletedIcon />}
        enableRedirect={true}
        enableAccionBtn={false}
        textRedirect='Prospectos'
        textCreateOrEditBtn='Guardar'
        urlRedirect={ROUTER_PATHS.ventas.prospectoNav}
        visibleReport={false}
        fnCreateOrEdit={form.handleSubmit(onSubmit, (error) => {
          handleErrorForm(error as ErrorMessagesForm);
        })}

        enableCreateOrEditBtn={hasPermission(PermissionsEnum.api_add_prospecto) && !bloquearVenta}
      >

        <Grid container spacing={2}>
          {
            esDifunto && (
              <Grid item {...gridSizeMdLg12}>
                <Alert severity="warning" onClose={() => { setEsDifunto(false) }}>
                  <AlertTitle>Información</AlertTitle>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography>{`La cédula ${form.getValues().identificacion} pertenece a una persona fallecida.`}</Typography>
                    </Grid>

                  </Grid>
                </Alert>
              </Grid>
            )
          }

          {
            form.getValues().segmentacion === SegmentacionENUM.NO_DATA && (
              <CustomAlertCard
                alertColor='info'
                alertTitle="Nota"
                alertMessage={texto.no_informacion_equifax} />
            )
          }


          {
            dataSolicitudBeneficio && dataSolicitudBeneficio.length > 0 && (
              <EstadoBeneficioCard
                razonSocial={form.getValues().razon_social || "—"}
                data={dataSolicitudBeneficio} />
            )
          }

          {
            esCliente && esCliente.alerta && (
              <Grid item {...gridSizeMdLg12}>
                <Alert
                  severity="warning"
                  sx={{
                    backgroundColor: '#fff3e0',
                    border: '2px solid #ff9800',
                    '& .MuiAlert-icon': { color: '#e65100' },
                    '& .MuiAlertTitle-root': { fontWeight: 'bold', color: '#e65100' },
                  }}
                  onClose={() => { setEsCliente({ ...esCliente, alerta: false }) }}
                >
                  <AlertTitle>Atención</AlertTitle>
                  <Grid container>
                    <Grid item xs={12}>
                      <span >{`El cliente ${esCliente.nombre} forma parte de FibraMax.`} </span>
                      <span >{`Validar con su supervisor que el cliente no tenga otra petición en curso`} </span>
                    </Grid>
                    {esCliente.linea && (
                      <Grid item xs={12}>
                        <span style={{ fontWeight: 'bold' }}>{`Servicios activos ${esCliente.linea} `}</span>
                      </Grid>
                    )}
                    {esCliente.plan && (
                      <div style={{
                        whiteSpace: 'pre-line'
                      }}>
                        {esCliente.plan}
                      </div>
                    )}
                  </Grid>
                </Alert>
              </Grid>
            )
          }

          {
            esReportado && (
              <Grid item {...gridSizeMdLg12}>
                <Alert severity="info" onClose={() => { setScoreBajo(false) }}>
                  <AlertTitle>Atención: Ingreso condicionado</AlertTitle>
                  <Grid container>
                    <Grid item xs={12}>
                      <span>{`El cliente ${form.getValues().razon_social} presenta antecedentes de problemas con otras empresas de telecomunicaciones.`} </span>
                      <span>{`Por favor, verifique con su supervisor o jefe inmediato si debe continuar con el proceso de ingreso.`} </span>
                    </Grid>
                  </Grid>
                </Alert>
              </Grid>
            )
          }

          {
            scoreBajo && (
              <Grid item {...gridSizeMdLg12}>
                <Alert severity="info" onClose={() => { setEsReportado(false) }}>
                  <AlertTitle>Atención: Puntaje Crediticio Bajo</AlertTitle>
                  <Grid container>
                    <Grid item xs={12}>
                      <span>{`El cliente ${form.getValues().razon_social} presenta un puntaje Equifax inferior al mínimo requerido. Por favor, solicite la aprobación de su supervisor antes de continuar con el proceso de ingreso.`} </span>
                    </Grid>
                  </Grid>
                </Alert>
              </Grid>
            )

          }

          <Grid item   {...gridSizeMdLg6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TabTextLabel text={texto.informacion_personal} mt={0} pb={2} pl={0} pt={0} />
              </Grid>
              <CustomAutocompleteArrString
                size={gridSizeMdLg6}
                label={texto.tipo_documento}
                name="tipo_identificacion"
                options={TIPO_IDENTIFICACIONES_CHOICE || []}
                defaultValue={form.getValues().tipo_identificacion || TipoIdentificacionEnumChoice.CEDULA}
                isLoadingData={false}
                control={control}
                error={errors.tipo_identificacion}
                helperText={errors.tipo_identificacion?.message}
                onChangeValue={(e) => {

                  reset({ tipo_identificacion: e });
                  setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
                  if (e == TipoDocumentoNameEnum.CEDULA || e == TipoDocumentoNameEnum.RUC) {
                    reset({ tipo_identificacion: form.getValues().tipo_identificacion });
                    setDisableIdentification(false);
                    return;
                  }
                  setDisableIdentification(true);

                }}
              />

              <Grid item container {...gridSizeMdLg6} spacing={1} alignItems={'center'}>
                <CustomTextFieldNumberComponente
                  disabled={disableIdentification}
                  size={gridSizeConst10}
                  max={form.getValues().tipo_identificacion == TipoDocumentoNameEnum.CEDULA ? 10 : 13}
                  type={TiposTextFieldNumberEnum.IDENTIFICACION}
                  label={texto.identificacion}
                  error={errors.identificacion}
                  helperText={errors.identificacion?.message}
                  control={control}
                  name="identificacion"
                  defaultValue={form.getValues().identificacion || ''}
                  onChangeValue={aux => handleBuscarIdentificacion(aux)}
                />
                <Grid item {...gridSizeConst2}>
                  <IconButton onClick={(e: any) => {
                    e.preventDefault();

                    if (form.getValues().identificacion)
                      return fnBuscarIdentificacion(form.getValues().identificacion || '')

                    setError('identificacion', { message: 'Campo Obligatorio' })

                  }} size="small">
                    <SearchIcon />
                  </IconButton>
                </Grid>
              </Grid>



              {form.getValues().tipo_identificacion === TipoDocumentoNameEnum.CEDULA && (
                <>

                  <CustomTextField
                    control={control}
                    name="razon_social"
                    type="texto_sin_numeros"
                    defaultValue={form.getValues().razon_social}
                    size={gridSizeMdLg12}
                    label={nombreRazonSocial}
                    error={errors.razon_social}
                    helperText={errors.razon_social?.message} />

                  <SampleDatePicker
                    minDate={subtractHundredYears()}
                    maxDate={formatDate(new Date)}
                    label={texto.fecha_nacimiento}
                    control={control}
                    error={errors.fecha_nacimiento}
                    helperText={errors.fecha_nacimiento?.message}
                    name="fecha_nacimiento"
                    textFieldKey={'fecha_nacimiento'}
                    size={gridSizeMdLg6}
                    defaultValue={form.getValues().fecha_nacimiento ?? ''}
                    onChangeValue={(e) => {
                      let edad = calcularEdad(e);
                      edad >= RangoEdadEnum.EDAD_MAXIMA && setAlert(true, texto.persona_tercera_edad, AlertSeverityEnum.info)
                      form.setValue('edad', edad)
                    }}
                  />

                  <CustomTextField
                    disabled={true}
                    control={control}
                    name="edad"
                    defaultValue={form.getValues().edad}
                    size={gridSizeMdLg6}
                    label={texto.edad}
                    error={errors.edad}
                    helperText={errors.edad?.message}
                  />


                  <CustomAutocomplete<Pais>
                    size={gridSizeMdLg6}
                    label={texto.nacionalidad}
                    name="nacionalidad"
                    options={dataPais || []}
                    valueKey="nacionalidad"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().nacionalidad}
                    isLoadingData={isLoadingPais}
                    control={control}
                    error={errors.nacionalidad}
                    helperText={errors.nacionalidad?.message}
                  />

                  <CustomAutocomplete<Pais>
                    size={gridSizeMdLg6}
                    label={texto.pais}
                    name="pais"
                    options={dataPais || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().pais}
                    isLoadingData={isLoadingPais}
                    control={control}
                    error={errors.pais}
                    helperText={errors.pais?.message}
                  />

                  {esResidente && (
                    <SampleCheckbox
                      disabled
                      label="Residencia Permanente o temporal"
                      name="residencia_permanente"
                      control={form.control}
                      defaultValue={!!form.getValues().residencia_permanente}
                      size={gridSizeMdLg12}
                    />
                  )
                  }

                  {form.getValues().es_discapacitado && (

                    <Grid item {...gridSizeMdLg12}>
                      <Alert variant="outlined" severity="info">
                        La persona cuenta con una discapacidad.
                      </Alert>
                    </Grid>
                  )

                  }
                </>
              )
              }

              {form.getValues().tipo_identificacion === TipoDocumentoNameEnum.RUC && (
                <>
                  <CustomTextField
                    disabled={false}
                    control={control}
                    name="razon_social"
                    type="texto_sin_numeros"
                    defaultValue={form.getValues().razon_social}
                    size={gridSizeMdLg12}
                    label={'Razon Social'}
                    error={errors.razon_social}
                    helperText={errors.razon_social?.message} />

                  <CustomAutocompleteArrString
                    label="Tipo contribuyente"
                    name="tipo_contribuyente"
                    options={TIPO_CONTRIBUYENTE_RUC}
                    control={form.control}
                    defaultValue={form.getValues().tipo_contribuyente || ''}
                    error={errors.tipo_contribuyente}
                    helperText={errors.tipo_contribuyente?.message?.toString() ?? ''}
                    isLoadingData={false}
                    size={gridSizeMdLg12}
                  />

                  <CustomAutocompleteArrString
                    label="Estado Contribuyente"
                    name="estado_contribuyente_ruc"
                    options={ESTADO_CONTRIBUYENTE_RUC}
                    control={form.control}
                    defaultValue={form.getValues().estado_contribuyente_ruc || ''}
                    error={errors.estado_contribuyente_ruc}
                    helperText={errors.estado_contribuyente_ruc?.message?.toString() ?? ''}
                    isLoadingData={false}
                    size={gridSizeMdLg6}
                  />

                  <CustomAutocompleteArrString
                    label="Regimen"
                    name="regimen"
                    options={REGIMEN_RUC}
                    control={form.control}
                    defaultValue={form.getValues().regimen || ''}
                    error={errors.regimen}
                    helperText={errors.regimen?.message?.toString() ?? ''}
                    isLoadingData={false}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextField
                    disabled={false}
                    control={control}
                    name="actividad_economica_principal"
                    type="texto_sin_numeros"
                    defaultValue={form.getValues().actividad_economica_principal}
                    size={gridSizeMdLg12}
                    label={'Actividad Economica Principal'}
                    error={errors.actividad_economica_principal}
                    helperText={errors.actividad_economica_principal?.message} />



                  {esResidente && (
                    <SampleCheckbox
                      disabled
                      label="Residencia Permanente o temporal"
                      name="residencia_permanente"
                      control={form.control}
                      defaultValue={!!form.getValues().residencia_permanente}
                      size={gridSizeMdLg12}
                    />
                  )}
                </>
              )}


              {(scoreBajo) && (

                <>
                  <Grid item {...gridSizeMdLg12}>
                    <Alert
                      severity="info"
                    >
                      {`Se requiere enviar una solicitud de revisión con el motivo correspondiente para validación del supervisor.`}
                    </Alert>
                  </Grid>

                  <CustomTextArea
                    size={gridSizeMdLg12}
                    label={"Motivo de solicitud"}
                    error={errors.observacion_solicitud}
                    helperText={errors.observacion_solicitud?.message}
                    control={control}
                    name="observacion_solicitud"
                    defaultValue={form.getValues().observacion_solicitud || ''}
                  />
                </>
              )

              }

              {aplicaSolicitudBeneficio
                && form.getValues().tipo_identificacion != TipoDocumentoNameEnum.RUC && (
                  <>
                    <Grid item xs={12} alignContent={"center"}>
                      <TabTextLabel text={texto.solicitud_beneficio} mt={0} pb={2} pl={0} pt={0} />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomAutocompleteNoForm
                        label="Motivo de Solicitud"
                        valueKey="nombre"
                        actualValueKey="codigo"
                        defaultValue={"NO_APLICA"}
                        value={MotivoSolicitudBeneficio}
                        // options
                        options={
                          (esReportado || scoreBajo)
                            ? SOLICITUD_BENEFICIO_SCORE_BAJO
                            : SOLICITUD_BENEFICIO_PROSPECTO_OPTIONS
                        }
                        // validation
                        onChangeValue={data => onChangeBeneficio(data)}
                      />
                    </Grid>

                    {/* SOLICITUD BENEFICIO PROSPECTO */}
                    <Grid item {...gridSizeMdLg12} >
                      {/* BENEFICIO TUTOR DISCAPACIDAD */}
                      {
                        form.getValues().es_curador_tutor &&
                        (
                          <>
                            <Grid item container {...gridSizeMdLg12} spacing={1} alignItems={'center'}>

                              <CustomTextFieldNumberComponente
                                disabled={disableIdentification}
                                size={gridSizeMdLg6}
                                max={10}
                                type={TiposTextFieldNumberEnum.IDENTIFICACION}
                                label={texto.ced_beneficio_tutordiscapacidad}
                                error={errors.identificacion_carga_personal}
                                helperText={errors.identificacion_carga_personal?.message}
                                control={control}
                                name="identificacion_carga_personal"
                                defaultValue={form.getValues().identificacion_carga_personal || ''}
                                onChangeValue={aux => handleFamiliarConDiscapacidad(aux)}
                              />
                            </Grid>


                            {
                              tutorDiscapacidad ?
                                <Grid item container gap={2} sx={{ marginY: 2 }} >
                                  <Grid {...gridSizeMdLg12} sx={{ paddingY: 1 }}>
                                    <Typography variant="h6">
                                      {form.getValues().razon_social_carga_personal}
                                    </Typography>
                                  </Grid>
                                  <Grid {...gridSizeMdLg5} sx={{ paddingY: 1 }}>
                                    <UploadImageComponent
                                      buttonText={'Foto Persona con Discapacidad'}
                                      selectedImage={fotoTutorDiscapacidad}
                                      setSelectedImage={setFotoTutorDiscapacidad}
                                      idInput={'entrada-fotoTutorDiscapacidad'}
                                    />
                                  </Grid>
                                  <Grid {...gridSizeMdLg5} sx={{ paddingY: 1 }}>
                                    <UploadImageComponent
                                      buttonText={'Foto Documento Legal Representante'}
                                      selectedImage={fotoDocumentoLegalRepresentante}
                                      setSelectedImage={setFotoDocumentoLegalRepresentante}
                                      idInput={'entrada-fotoDocumentoLegalRepresentante'}
                                    />
                                  </Grid>
                                </Grid>
                                :
                                <></>
                            }

                          </>
                        )
                      }


                    </Grid>
                  </>
                )}

              {form.getValues().es_gremio && (
                <>
                  <Grid item {...gridSizeMdLg6} >
                    <UploadImageComponent
                      buttonText={'Identificación Personal'}
                      selectedImage={fileIdentificacion}
                      setSelectedImage={setFileIdentificacion}
                      idInput={'identificacion-personal'}
                    />
                  </Grid>

                  <Grid item {...gridSizeMdLg6} >
                    <UploadImageComponent
                      buttonText={'Credencial de Empresa'}
                      selectedImage={fileCredencialEmpresa}
                      setSelectedImage={setFileCredencialEmpresa}
                      idInput={'credencial-empresa'}
                    />
                  </Grid>

                  {/* <Grid item {...gridSizeMdLg6} >
                    <UploadImageComponent
                      buttonText={'Documento Legal - RUC Empresa'}
                      selectedImage={fileDocLegalEmpresa}
                      setSelectedImage={setFileDocLegalEmpresa}
                      idInput={'documento-legal-ruc-empresa'}
                    />
                  </Grid> */}
                </>
              )}



            </Grid>

          </Grid>

          <Grid item {...gridSizeMdLg6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TabTextLabel text={texto.informacion_equifax} mt={0} pb={2} pl={0} pt={0} />
              </Grid>


              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score"
                defaultValue={form.getValues().puntaje_score || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score}
                error={errors.puntaje_score}
                helperText={errors.puntaje_score?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score_sobreendeudamiento"
                defaultValue={form.getValues().puntaje_score_sobreendeudamiento || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score_sobreendeudamiento}
                error={errors.puntaje_score_sobreendeudamiento}
                helperText={errors.puntaje_score_sobreendeudamiento?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score_empresa"
                defaultValue={form.getValues().puntaje_score_empresa || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score_empresa}
                error={errors.puntaje_score_empresa}
                helperText={errors.puntaje_score_empresa?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="segmentacion"
                defaultValue={form.getValues().segmentacion || ''}
                size={gridSizeMdLg12}

                label={texto.segmentacion}
                error={errors.segmentacion}
                helperText={errors.segmentacion?.message} />

              <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
                customRestriccionCelular={valorRestriccionCel}
              />

            </Grid>
          </Grid>


          {/* <Grid container item {...gridSizeMdLg12}>

            <Grid item xs={12} alignContent={"center"}>
              <TabTextLabel text={'Canje/Evento'} mt={0} pb={2} pl={0} pt={0} />
            </Grid>

            <CondicionVentaPymes
              form={form}
              servicio={ServicioCanejeEvento.HOME}
              handleDataSolicitud={(data) => {
                handleBuscarIdentificacion(data.identificacion)
              }}
            />

          </Grid> */}


        </Grid>


      </SingleTableBoxScene>

      {
        modalProspectoEnEspera && (
          <ScrollableDialogProps
            onCloseIcon={() => setModalProspectoEnEspera(false)}
            open={modalProspectoEnEspera}
            title="Solicitar liberación de Prospecto"
            dialogContentText={`El prospecto con la identificación "${dataProspectoEnEspera?.identificacion}" tiene un prospecto creado.
              ¿Te gustaría solicitar un desbloqueo al supervisor?`}
            showConfirmBtn={true}
            onConfirm={async () => {
              try {
                const resp = await postSolicitudFallido({
                  prospecto: dataProspectoEnEspera?.codigo!,
                });
                setAlert(true, resp.message, resp.status);
              } catch (error) {
                handleAxiosError(error);
              } finally {
                setModalProspectoEnEspera(false)

              }
            }}
            confirmVariantBtn={'contained'}
            onClose={() => {
              setModalProspectoEnEspera(false)
            }}
            contentNode={

              <Grid container spacing={3}>

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Fecha de registro'}
                  defaultValue={formatDateWithTimeAMPM(dataProspectoEnEspera?.fecha_creacion!)}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Canal de venta'}
                  defaultValue={dataProspectoEnEspera?.canal_venta_create}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Estado'}
                  defaultValue={EstadoProspectoEnum.EN_ESPERA}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Vendedor'}
                  defaultValue={dataProspectoEnEspera?.user_create}
                  size={gridSizeMdLg6}
                />

                <Grid item xs={12}>
                  <Alert severity="info">{`El cliente tiene registrado PROSPECTO`}</Alert>
                </Grid>

                {
                  (dataProspectoEnEspera?.es_ayuda_social || dataProspectoEnEspera?.es_bono_humano || dataProspectoEnEspera?.es_curador_tutor) && (
                    <Grid item xs={12}>
                      <Alert severity="info">{`El cliente tiene registrado SOLICITUD DE BENEFICIO`}</Alert>
                    </Grid>
                  )
                }

              </Grid>
            }
          />
        )
      }

      {
        modalProspectoEnProceso && (
          <ScrollableDialogProps
            onCloseIcon={() => setModalProspectoEnProceso(false)}
            open={modalProspectoEnProceso}
            title="Solicitar nueva línea"
            dialogContentText={`El cliente con identificación "${dataProspectoEnProceso?.identificacion!}" tiene un servicio en proceso.
              ¿Te gustaría solicitar una nueva línea al supervisor?`}
            showConfirmBtn={true}
            onConfirm={async () => {
              try {
                const resp = await postSolicitudSupervicion({
                  identificacion: dataProspectoEnProceso?.identificacion!,
                  estado_solicitud: EstadoProspectoEnum.EN_ESPERA,
                  estado: true,
                });
                setAlert(true, resp.message, resp.status);
              } catch (error) {
                handleAxiosError(error);
              } finally {
                setModalProspectoEnProceso(false)
              }
            }}
            confirmVariantBtn={'contained'}
            onClose={() => {
              setModalProspectoEnProceso(false)
            }}
            contentNode={

              <Grid container spacing={3}>

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Fecha de registro'}
                  defaultValue={formatDateWithTimeAMPM(dataProspectoEnProceso?.fecha_creacion!)}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Canal de venta'}
                  defaultValue={dataProspectoEnProceso?.canal_venta_create}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Estado'}
                  defaultValue={EstadoProspectoEnum.EN_PROCESO}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Vendedor'}
                  defaultValue={dataProspectoEnProceso?.user_create}
                  size={gridSizeMdLg6}
                />

                <Grid item xs={12}>
                  <Alert severity="success">{`El cliente tiene una venta EN PROCESO`}</Alert>
                </Grid>

              </Grid>
            }
          />
        )
      }

      <ModalReportadoTelco
        open={bloquearVenta}
        onClose={cleanProspecto}
      />

    </>
  );

}